import React from "react";

export default function StatCard({ title, value, subtitle, icon: Icon, tone = "brand" }) {
  const tones = {
    brand: "from-brand-700 to-brand-500",
    success: "from-income to-emerald-500",
    danger: "from-expense to-rose-500",
    accent: "from-accent-500 to-amber-400"
  };

  return (
    <div className="glass-card overflow-hidden p-3 sm:p-4">
      <div className="flex items-start gap-3">
        <div className="min-w-0 flex-1">
          <p className="text-[11px] font-extrabold text-slate-500 sm:text-xs">{title}</p>
          <p className="mt-1 break-words text-[15px] font-extrabold leading-7 text-slate-900 sm:mt-2 sm:text-[22px]">
            {value}
          </p>
          {subtitle ? (
            <p className="mt-1 text-[10px] leading-5 text-slate-500 sm:text-xs">{subtitle}</p>
          ) : null}
        </div>

        {Icon ? (
          <div className={`flex h-10 w-10 shrink-0 items-center justify-center rounded-2xl bg-gradient-to-br ${tones[tone]} text-white shadow-md sm:h-12 sm:w-12`}>
            <Icon className="h-5 w-5 sm:h-6 sm:w-6" />
          </div>
        ) : null}
      </div>
    </div>
  );
}
